module.exports = __webpack_public_path__ + "assets/img/Type BS (13).fbfafc86.jpg";